<template lang="pug">
  div()
    app-header()

    section(class='u-bg-primary')
      div(class='u-flex o-wrapper u-py5 u-flex-wrap u-items-start')
        div(data-aos='fade-right' class='u-white u-7/12@laptop u-6/12@tablet u-12/12')
          div(class='u-8/12@laptop u-10/12@tablet u-mx-auto u-px2')
            h2(class='u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0')
              span(class='u-color-secondary u-block') Conduce
              span(class='u-white u-block') con {{company.name}}

            p(class='u-color-text u-mb0 u-mt0 u-fz-h4') Únete como conductor o afilia tu auto.
            p(class='u-color-text u-mb4 u-mt0 u-fz-h4') Disfruta de las ventas de {{company.name}}

            figure(class='u-m0 u-show@laptop')
              img(src='/images/car_pavill.png')
        div(data-aos='fade-left' class='u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex')
          div(class='u-flex u-flex-wrap u-px2 u-items-center u-mb2')
            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='a1' type='radio' name='a' class='u-mr3', :value='true' v-model='form.hasVehicle')
              label(class='c-input__label u-color-text' for='a1') Tengo vehículo

            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='a2' type='radio' name='a' class='', :value='false' v-model='form.hasVehicle')
              label(class='c-input__label u-color-text' for='a2') No tengo vehículo

          input-validate(
            v-model='form.firstname', :rule='rules.firstname' icon='user' placeholder='Nombres', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.lastname', :rule='rules.lastname' placeholder='Apellidos', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.dni', :rule='rules.dni' icon='message' placeholder='DNI', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.cellphone', :rule='rules.cellphone' icon='cellphone' placeholder='Celular o teléfono', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.driverLicense', :rule='rules.driverLicense' icon='driver_license' placeholder='Licencia de conductor', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align', :clear='clearForm')

          input-validate(v-if='form.hasVehicle'
            v-model='form.vehiclePlate', :rule='rules.vehiclePlate' placeholder='Placa de vehículo', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(v-if='form.hasVehicle'
            v-model='form.year', :rule='rules.year' placeholder='Año', :validation='toggleValidate' mask="####", :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          div(class='u-flex u-flex-wrap u-px2 u-items-center u-mb2' v-if='form.hasVehicle')
            label( class='u-block u-mb2 u-mr3 u-color-text') ¿Cuentas con la herramienta de radio base?
            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='x1' type='radio' name='x' class='u-mr2', :value='true' v-model='form.baseRadio')
              label(class='c-input__label u-color-text' for='x1') Si

            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='x2' type='radio' name='x' class='u-mr2', :value='false' v-model='form.baseRadio')
              label(class='c-input__label u-color-text' for='x2') No

          input-validate(v-if='form.baseRadio'
            v-model='form.model', :rule='rules.model' placeholder='Modelo', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(v-if='form.baseRadio'
            v-model='form.chanels', :rule='rules.chanels' placeholder='Canales', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.professionaldriveExperience', :rule='rules.professionaldriveExperience' placeholder='Cuéntanos tu experiencia como conductor profesional', :validation='toggleValidate' type='textarea'
            wrapper-class='c-input' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align', :clear='clearForm')

          input-validate(
            v-model='form.whyWork', :rule='rules.whyWork' placeholder='¿Por qué deseas trabajar con nosotros?', :validation='toggleValidate', :clear='clearForm'
            wrapper-class='c-input' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          div(class='u-px2 u-12/12')
            button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2' @click='postForm') Registrarse

    section(class='u-pt5 o-wrapper' v-if='company.parnerts && company.parnerts.length > 0')
      h3(data-aos='fade-up' class='u-mt0 u-mb3 u-fz-h1 u-center u-line-1')
        span(class='u-color-secondary u-inline-block') Convenios&nbsp;
        span(class='u-inline-block u-fw-light') que te benefician

      p(data-aos='fade-up' class='o-container o-wrapper u-center u-mb4') Convenios con empresas privadas y públicas con ubicaciones en paraderos estratégicos en toda la ciudad, trabajamos con la cadena de mercados del Perú Plaza Vea.

      ul(class='u-flex u-flex-wrap u-pl0 u-list-none u-mb0 u-justify-center')
        li(data-aos='fade-up'  v-for='(parnert, index) in company.parnerts' class='u-px4 u-mb3', :class="{'u-12/12 u-center u-mb4' : index === 0}")
          a(style='height:60px' class='u-m0 u-block', :href='parnert.link' target='_blank')
            img(:src='parnert.imageUrl', :title='parnert.title' style='max-height:100%')

    section(class='u-pt5 o-wrapper' v-if='whereabouts.length > 0')
      h3(data-aos='fade-up'  class='u-mt0 u-mb4 u-fz-h1 u-center u-line-1')
        span(class='u-color-secondary u-inline-block') Paraderos&nbsp;
        span(class='u-inline-block u-fw-light') estratégicos

      ul(class='u-mt0 u-pt3 u-flex u-flex-wrap u-list-none u-mb0 u-pl0 u-justify-center')
        li(data-aos='fade-up'  v-for='whereabout in whereabouts' class='u-px3 u-mb4 u-4/12@tablet u-12/12 u-px3')
          figure(class='u-mb0 u-mt0 u-mx2 u-br16 u-overflow-hidden')
            img(:src='whereabout.imageUrl')
          p(class='u-mb2 u-px2 u-center u-color-tertiary u-fz-h4 u-fw-light') {{whereabout.name}}
          p(class='u-px2 u-mt0 u-mb3 u-center u-color-dark') {{whereabout.address}}

    section(class='o-wrapper u-center u-pt5')
      h3(data-aos='fade-up'  class='u-color-primary u-fz-h3 u-mt0 u-mb3') ¿Te interesa?
      a(data-aos='fade-up'  class='c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center' href="#"  v-scroll-to="'#root'") Empieza hoy

    app-footer(class='u-mt5')
    loading(message='Enviando' v-if='isLoading')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false' message='Nos pondremos en contacto con usted.')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'

  export default {
    name: 'DriverScreen',
    data () {
      return {
        toggleValidate: false,
        formValidate: false,
        isLoading: false,
        clearForm: false,
        isShowModalError: false,
        isShowModalConfirm: false,
        form: {
          hasVehicle: true,
          firstname: '',
          lastname: '',
          dni: '',
          cellphone: '',
          driverLicense: '',
          vehiclePlate: '',
          year: null,
          baseRadio: true,
          model: '',
          chanels: '',
          professionaldriveExperience: '',
          whyWork: ''
        },
        rules: {
          firstname: 'required|name',
          lastname: 'required|name',
          dni: 'required',
          cellphone: 'required|phone',
          driverLicense: 'required',
          vehiclePlate: 'required',
          year: 'required|integer',
          model: 'required',
          chanels: 'required'
        },
        whereabouts: []
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`${window.API_URL}/drivers`, this.form)
            .then((response) => {
              this.isLoading = false
              this.isShowModalConfirm = true
              this.form = {
                hasVehicle: true,
                firstname: '',
                lastname: '',
                dni: '',
                cellphone: '',
                driverLicense: '',
                vehiclePlate: '',
                year: null,
                baseRadio: true,
                model: '',
                chanels: '',
                professionaldriveExperience: '',
                whyWork: ''
              }
              this.clearForm = true
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        this.toggleValidate = !this.toggleValidate
        let validation = new Validator(this.form, this.rules)

        validation.passes()
        this.formValidate = validation.passes()
      },

      getWhereabouts () {
        axios.get(`${window.API_URL}/whereabouts`)
          .then(({data}) => {
            this.whereabouts = data.data
          })
      }
    },

    created () {
      this.getWhereabouts()
    },

    watch: {
      'form.baseRadio' (val) {
        if (val) {
          this.rules.model = 'required'
          this.rules.chanels = 'required'
        } else {
          this.rules.model = ''
          this.rules.chanels = ''
          this.form.model = ''
          this.form.chanels = ''
        }
      },

      'form.hasVehicle' (val) {
        if (val) {
          this.rules.vehiclePlate = 'required'
          this.rules.year = 'required|integer'
        } else {
          this.rules.vehiclePlate = ''
          this.rules.year = ''
          this.form.vehiclePlate = ''
          this.form.year = ''
          this.form.baseRadio = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Driver/components/DriverScreen.vue